import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
    &:not(:last-child){
    margin-bottom: 50px;

}
`

const Title = styled.span`
    font-size: 14px;
    font-weight:600;
`

const Grid = styled.div`
    margin-top:10px;
    display:flex;   
    overflow: auto;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        background:rgba(0,0,0,0.1)
    }
    &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255,255,255,0.5);
    }
    @media screen and (max-width:768px) {
        width:100%;
        margin-top:10px;
        display:flex;
        overflow-x:auto
}
`

const Cast = ({ title, children }) => {
    return (
        <Container>
            <Title>{title}</Title>
            <Grid>{children}</Grid>
        </Container>
    )
}

Cast.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any
}

export default Cast